import React from 'react';
import { ShieldCheck, CreditCard, Lock, ArrowRight } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PurchaseSection() {
  const checkoutLink = 'https://checkout.ebookpoint.shop/cart/59751057227857:1';
  return <div className="bg-white rounded-2xl p-5 shadow-2xl my-8 relative overflow-hidden border-4 border-tennis-green" id="compra" data-id="element-108">
      <div className="absolute top-0 left-0 w-full bg-tennis-green text-white text-center py-1 text-xs font-bold uppercase tracking-widest" data-id="element-109">
        Oferta Especial
      </div>

      <div className="mt-6 mb-4 text-center" data-id="element-110">
        <h3 className="text-2xl font-black text-gray-900 uppercase leading-tight mb-2" data-id="element-111">
          Resumen de tu pedido
        </h3>
        <p className="text-gray-600 text-sm" data-id="element-112">
          Acceso inmediato a todo el material
        </p>
      </div>

      <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-200" data-id="element-113">
        <ul className="space-y-3 text-sm text-gray-700 font-medium" data-id="element-114">
          <li className="flex items-start gap-2" data-id="element-115">
            <CheckIcon data-id="element-116" />{' '}
            <span className="flex-1" data-id="element-117">Tenis Pro System (7 Módulos)</span>{' '}
            <span className="text-gray-400 line-through" data-id="element-118">$25.000</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-119">
            <CheckIcon data-id="element-120" />{' '}
            <span className="flex-1" data-id="element-121">Bono 1: Planificador Semanal</span>{' '}
            <span className="text-tennis-green font-bold" data-id="element-122">GRATIS</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-123">
            <CheckIcon data-id="element-124" />{' '}
            <span className="flex-1" data-id="element-125">Bono 2: Rutina Pre-partido</span>{' '}
            <span className="text-tennis-green font-bold" data-id="element-126">GRATIS</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-127">
            <CheckIcon data-id="element-128" />{' '}
            <span className="flex-1" data-id="element-129">Bono 3: Ficha de Lesiones</span>{' '}
            <span className="text-tennis-green font-bold" data-id="element-130">GRATIS</span>
          </li>
          <li className="flex items-start gap-2" data-id="element-131">
            <CheckIcon data-id="element-132" />{' '}
            <span className="flex-1" data-id="element-133">Bono 4: Protocolo Recuperación</span>{' '}
            <span className="text-tennis-green font-bold" data-id="element-134">GRATIS</span>
          </li>
          <li className="flex items-start gap-2 border-b border-gray-200 pb-3" data-id="element-135">
            <CheckIcon data-id="element-136" />{' '}
            <span className="flex-1" data-id="element-137">Bono 5: Cuaderno Táctico</span>{' '}
            <span className="text-tennis-green font-bold" data-id="element-138">GRATIS</span>
          </li>
          <li className="flex justify-between items-center pt-2 text-lg font-black text-gray-900" data-id="element-139">
            <span data-id="element-140">Total a pagar hoy:</span>
            <div className="text-right" data-id="element-141">
              <div className="text-sm text-gray-400 line-through font-normal" data-id="element-142">
                $49.990
              </div>
              <div className="text-tennis-green text-2xl" data-id="element-143">$19.999</div>
            </div>
          </li>
        </ul>
      </div>

      <CountdownTimer data-id="element-144" />

      <a href={checkoutLink} className="w-full bg-tennis-green hover:bg-green-600 text-white font-black text-lg py-4 px-6 rounded-xl shadow-lg shadow-tennis-green/30 flex flex-col items-center justify-center transition-transform active:scale-95 mb-4" data-id="element-145">
        <span className="flex items-center gap-2" data-id="element-146">
          QUIERO DEFINIR MIS PARTIDOS <ArrowRight className="w-5 h-5" data-id="element-147" />
        </span>
        <span className="text-xs font-normal opacity-90 mt-1" data-id="element-148">
          Pago 100% Seguro y Encriptado
        </span>
      </a>

      <div className="flex justify-center gap-4 text-gray-400 mb-4" data-id="element-149">
        <CreditCard className="w-6 h-6" data-id="element-150" />
        <Lock className="w-6 h-6" data-id="element-151" />
        <ShieldCheck className="w-6 h-6" data-id="element-152" />
      </div>

      <p className="text-center text-xs text-gray-500" data-id="element-153">
        Al hacer clic, serás redirigido a nuestra plataforma de pago segura.
      </p>
    </div>;
}
function CheckIcon() {
  return <div className="bg-tennis-green/20 p-0.5 rounded-full mt-0.5" data-id="element-154">
      <svg className="w-3 h-3 text-tennis-green" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-155">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-156" />
      </svg>
    </div>;
}